import BreakdownTooltipGraph from './BreakdownTooltipGraph';

export default BreakdownTooltipGraph;
